import createVueComponent from '../createVueComponent';

const ShieldMinus = createVueComponent('ShieldMinusIcon', [
  ['path', { d: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10', key: '1irkt0' }],
  ['path', { d: 'M8 11h8', key: 'vwpz6n' }],
]);

export default ShieldMinus;
